export default "__VITE_ASSET__97JGuigh__"